/**
 * Central export file for all Universal CRM Table utilities
 */

// Unified field rendering utilities (display and edit modes)
export {
  renderFieldDisplay,
  renderFieldInput,
  isUUID,
  normalizeMultiUserData,
  convertFieldValue,
  createUpdatePayload,
} from "./unified-field-renderer";

// Cell rendering utilities
export { renderCellValue } from "./cell-value-rendering";

export { renderEditableCell } from "./editable-cell-rendering";

// Badge variant utilities
export {
  getStatusBadgeVariant,
  getPriorityBadgeVariant,
  getStatusColorClasses,
  getPriorityColorClasses,
  getEntryTypeColorClasses,
  getBillableStatusColorClasses,
  getApprovalStatusColorClasses,
  getSyncStatusColorClasses,
} from "./badge-variants";

// Filtering and sorting utilities
export {
  applyAdvancedFilter,
  applyMultiColumnSort,
  applySingleColumnSort,
} from "./filtering-sorting";

// Inline editing utilities
export { handleCellEdit, handleCellSave, handleCellCancel } from "./inline-editing";

// CSV export utilities
export { handleExportCSV } from "./csv-export";

// Column management utilities
export {
  handleColumnResize,
  resetColumnWidths,
  getColumnStyle,
  handleDragStart,
  handleDragOver,
  handleDrop,
  handleDragEnd,
} from "./column-management";
